import { render, staticRenderFns } from "./InAppPurchaseProducts.vue?vue&type=template&id=65958ccf"
import script from "./InAppPurchaseProducts.vue?vue&type=script&lang=js"
export * from "./InAppPurchaseProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports